const addressInput = document.querySelector(".address-input");
const addressLine1Element = document.querySelector('#AddressLine1');
const addressLine2Element = document.querySelector('#AddressLine2');
const cityElement = document.querySelector('#City');
const postcodeElement = document.querySelector('#Postcode');
const countryElement = document.querySelector('#Country');

let autocomplete = null;

function changeElements(callback) {
  var elements = [addressLine1Element, addressLine2Element, cityElement, postcodeElement];

  elements.forEach(element => {
    if(callback) {
      callback(element);
    }
  });
}

function setComponentRestrictions() {
  let countries = window['countryList'] || [];
  let selectedCountry = countries.find(x=> x.Name == countryElement.value); 
  let componentRestrictions = {country: [selectedCountry.Id]};
  autocomplete.setComponentRestrictions(componentRestrictions);
}

function initAutocomplete() {

  const options = {
    fields: ["address_components"],
    strictBounds: false
  };
  
  autocomplete = new google.maps.places.Autocomplete(addressInput, options);
  setComponentRestrictions();
  autocomplete.addListener("place_changed", () => {

    changeElements((element) => {      
      element.value = "";
      var row = element.closest('.form-row');
      row.classList.remove("hidden");
    });
    
    var place = autocomplete.getPlace().address_components;

    for (var component of place) {
      const componentType = component.types[0];

      switch (componentType) {

          
        case "premise":
        case "street_number":
          addressLine1Element.value =  addressLine1Element.value + ' ' + component.long_name;
          break;

        case "neighborhood":
        case "route":
          addressLine2Element.value = addressLine2Element.value + ' ' + component.long_name;
          break;

        case "postal_town":
        case "locality":
          cityElement.value = component.long_name;
          break;

        case "postal_code":
          postcodeElement.value = component.long_name;
          break;
      }
    }   
  });
}

if(addressInput && countryElement) {
  initAutocomplete();

  countryElement.addEventListener('change', function() {
    changeElements((element) => {
      element.value = "";
    });
    initAutocomplete();
  });
}